export default "__VITE_ASSET__DPpg4eyL__"